/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon16Light = forwardRef('ArrowParallelHIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.756 1.572a.5.5 0 1 1 .707-.707l2.618 2.619a1.437 1.437 0 0 1 0 2.032l-2.618 2.619a.5.5 0 1 1-.707-.707L12.183 5H3a.5.5 0 0 1 0-1h9.183L9.756 1.572Z" }),
        React.createElement("path", { d: "M6.244 8.572a.5.5 0 1 0-.707-.707l-2.618 2.618a1.438 1.438 0 0 0 0 2.034l2.618 2.618a.5.5 0 1 0 .707-.707L3.816 12H13a.5.5 0 0 0 0-1H3.816l2.428-2.428Z" })));
});
